'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { EVENT_DETAILS } from '../constants';

const CONTAINER_ANIMATION = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.2,
    },
  },
};

const TITLE_ANIMATION = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const ITEM_ANIMATION = {
  hidden: { opacity: 0, y: 15 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

export const EventInfoSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="bg-Gray-black px-32 py-80">
      <motion.div
        ref={ref}
        variants={CONTAINER_ANIMATION}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
        className="flex flex-col gap-20"
      >
        <motion.h2
          variants={TITLE_ANIMATION}
          className="font-800 text-Gray-white typo-h4"
        >
          행사개요
        </motion.h2>

        <dl className="flex flex-col break-keep">
          {EVENT_DETAILS.map((item) => (
            <motion.div
              key={item.label}
              variants={ITEM_ANIMATION}
              className="flex gap-10 border-b border-Gray-800 py-12"
            >
              <dt className="w-70 font-600 text-Gray-white typo-body3">
                {item.label}
              </dt>

              <dd className="flex-1 whitespace-pre-wrap font-400 text-Gray-550 typo-body3">
                {item.value}
              </dd>
            </motion.div>
          ))}
        </dl>
      </motion.div>
    </section>
  );
};
